import React, {
    useContext,
    useEffect,
    useState,
} from "react"

import {
    Context,
    EMETLContext,
} from "../../../Model/Contexts/AppContext"

import { 
    Button,
    Spinner,
} from "react-bootstrap"

import Card from "react-bootstrap/Card"
import ListGroup from "react-bootstrap/ListGroup"
import EMETLFieldManualCell from "../EMETLFieldManualCell"

import EMETLAssessmentManager, { 
    EMETLAssessmentTaskWithDetails, 
} from "../../../Model/EMETLAssessment.m"

import { 
    Task, 
} from "../../../API"

import EMETLTaskPDFModal from "../EMETLTaskPDFModal"
import "./style.css"

export type EMETLFieldManualProps = {
    wantsSelection?: boolean,
    doneSelecting?: (selectedTasks: number[]) => void,
    selectionColor?: string,
    selectionHoverColor?: string,
    cellHoverColor?: string,
    tasksAlreadySelected?: number[],
    fromModal?: boolean,
}

const EMETLFieldManual = (props?: EMETLFieldManualProps) => {
    EMETLAssessmentManager.ctx = useContext(Context)
    const {
        modal: {
            content,
            setContent,
            setTitle,
        },
    } = EMETLAssessmentManager.ctx as EMETLContext

    const {
        wantsSelection = false,
        cellHoverColor = "rgb(242, 242, 242)",
        doneSelecting = () => {/**/},
        selectionColor = "rgb(205, 241, 244)",
        selectionHoverColor = "rgba(178, 239, 245, 1)",
        tasksAlreadySelected = [],
        fromModal = false,
    } = props

    const [tasks, setTasks] = useState([])
    const [loading, setLoading] = useState(false)
    const [selectedTasks, setSelectedTasks] = useState<number[]>(tasksAlreadySelected)

    const _init = async () => {
        setLoading(true)
        const tasks = await EMETLAssessmentManager.loadTasks()
        setLoading(false)
        if (tasks) {
            setTasks(tasks.sort((a: Task, b: Task) => {
                return a.ID - b.ID
            }))
        }
    }

    const showTaskPDF = async (task: EMETLAssessmentTaskWithDetails) => {
        if (fromModal) {
            const priorContent = content
            setContent(
                <>
                    <a 
                        className="btn-primary"
                        onClick={() => {
                            setContent(priorContent)
                            setTitle("Select Tasks for Assessment")
                        }}
                    >
                        &larr; Back to Task Selection
                    </a>
                    <EMETLTaskPDFModal
                        task={task}
                    />
                </>
            )
        } else {
            setContent(
                <EMETLTaskPDFModal
                    task={task}
                />
            )
        }
        setTitle(task.Number)
    }

    useEffect(() => {
        _init()
    }, [])

    
    return (
        <div
            className="emetlFieldManual"
        >
            {loading ? (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Spinner animation="border" />
                </div>
            ) : (
                <>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "flex-end",
                        }}
                    >
                        {wantsSelection && (
                            <Button 
                                onClick={() => doneSelecting(selectedTasks)}
                                style={{
                                    marginBottom: "10px",
                                    alignSelf: "flex-end",
                                }}
                            >
                                Done Selecting Tasks ({selectedTasks.length})
                            </Button>
                        )}
                    </div>
                    <Card>
                        <ListGroup
                            variant="flush"
                        >
                            {tasks && tasks.map((task: EMETLAssessmentTaskWithDetails) => (
                                <EMETLFieldManualCell
                                    key={task.Number}
                                    infoFunction={wantsSelection ? () => showTaskPDF(task) : null}
                                    subtitle={task.Name}
                                    onClick={wantsSelection ? () => {
                                        if (selectedTasks.includes(task?.ID)) {
                                            const tasks = structuredClone(selectedTasks)
                                            
                                            setSelectedTasks(tasks.filter(t => t !== task.ID))
                                        } else {
                                            const tasks = structuredClone(selectedTasks)
                                            tasks.push(task.ID)
                                            setSelectedTasks(tasks)
                                        }
                                    } : () => showTaskPDF(task)}
                                    style={{
                                        backgroundColor: wantsSelection && selectedTasks.includes(task.ID) ? selectionColor : "initial",
                                    }}
                                    onHoverColor={wantsSelection && selectedTasks.includes(task.ID) ? selectionHoverColor : cellHoverColor}
                                >
                                    {task.Number}
                                </EMETLFieldManualCell>
                            ))}
                        </ListGroup>
                    </Card>
                </>
            )}
        </div>
    )
}

export default EMETLFieldManual
